import MobileSendTestEmailDialog from './MobileSendTestEmailDialog';

export default MobileSendTestEmailDialog;
